import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyBj61ec4kuFRqtytZeKY8OYFJfp8WCAcgY",
  authDomain: "yuwathipathi-483ee.firebaseapp.com",
  projectId: "yuwathipathi-483ee",
  storageBucket: "yuwathipathi-483ee.firebasestorage.app",
  messagingSenderId: "658166107005",
  appId: "1:658166107005:web:2ee1fc834e678e233e5a14",
  measurementId: "G-Q7K59F92DH"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);